export default __webpack_public_path__ + "static/media/ShowMenu.1efa23b9.svg";